import {BaseDTO} from '../../../common/models/BaseDTO';

export class TransactionPaymentLinkDTO extends BaseDTO {
  transactionId: number;
}
